<template>
  <div class="layout__sub-menu">
    <Menu :active-name="activeName"
          :open-names="openNames"
          width="224px"
          ref="menu"
          @on-select="handleSelectMenu"
          class="v-menu">
      <template v-for="item in routerList">
        <Submenu :name="item.name"
                 :key="item.name"
                 v-if="item.children && item.children.length && isShowPermissionMenu(item)">
          <template slot="title">{{item.meta.title}}</template>
          <template v-for="child in item.children">
            <MenuItem :name="child.name"
                      :to="child.path"
                      v-if="isShowPermissionMenu(child)"
                      :key="child.name">{{child.meta.title}}</MenuItem>
          </template>
        </Submenu>
        <MenuItem :name="item.name"
                  :to="item.path"
                  v-else-if="isShowPermissionMenu(item)"
                  :key="item.name">{{item.meta.title}}</MenuItem>
      </template>
    </Menu>
  </div>
</template>

<script>
import mainRouterList from '@/router/mainRouterList';
import { mapState } from 'vuex';
import bus from '@/utils/bus';

export default {
  name: 'layoutHeader',
  computed: {
    ...mapState('user', ['menuList']),
    activeName() {
      return this.$route.name;
    },
    parentActiveName() {
      return this.$route.name.split('-')[0];
    },
    routerList() {
      return mainRouterList[0].children.find((c) => c.name === this.parentActiveName).children;
    },
    openNames() {
      return [this.$route.name.split('-').slice(0, 2).join('-')];
    },
  },
  data() {
    return {
      selectedName: '',
    };
  },
  created() {
    bus.$on('updateActiveName', () => {
      this.$nextTick(() => {
        if (this.selectedName && this.selectedName !== this.activeName
          && this.activeName === 'dashboard-settlement-payment') {
          const ele = document.querySelector('a[href="#/dashboard/settlement/payment"]');
          if (ele) {
            ele.click();
          }
        }
      });
    });
  },
  watch: {
    parentActiveName() {
      this.$nextTick(() => {
        this.$refs.menu.updateActiveName();
      });
    },
  },
  methods: {
    isShowPermissionMenu(item) {
      const { meta } = item;
      const { permission } = meta;
      if (permission) {
        return this.menuList.includes(permission);
      }
      return true;
    },
    handleSelectMenu(name) {
      this.selectedName = name;
    },
  },
};
</script>

<style lang="less">
  .layout__sub-menu{
    .v-menu{
      color: rgba(0, 0, 0, 0.54);
      &.ivu-menu-vertical{
        height: 100%;
        padding-top: 8px;
      }
      &.ivu-menu-vertical .ivu-menu-item,
      &.ivu-menu-vertical .ivu-menu-submenu-title{
        padding: 0 16px;
        height: 40px;
        line-height: 40px;
        font-weight: 500;
        margin-bottom: 8px;
      }
      &.ivu-menu-light.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item {
        position: relative;
        padding-left: 32px!important;
        color: rgba(0, 0, 0, 0.54);
        &:before{
          content: "";
          position: absolute;
          left: 16px;
          top: 12px;
          width: 5px;
          height: 16px;
          border-radius: 3px;
          background-color: rgba(0, 0, 0, 0.54);
          opacity: 0;
          transition: opacity .2s;
        }
        &.ivu-menu-item-active{
          background-color: transparent;
          color: @primary-color;
          &:hover{
            color: @primary-color;
          }
          &:before {
            opacity: 1;
            background-color: @primary-color;
          }
        }
        &:hover {
          background-color: transparent;
          color: rgb(101, 113, 128);
          &:before {
            opacity: 1;
          }
        }
      }
      &.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu){
        background-color: rgba(0, 0, 0, 0.08);
        color: @primary-color;
        &:after{
          display: none;
        }
      }
      &.ivu-menu-vertical .ivu-menu-child-item-active .ivu-menu-submenu-title{
        background-color: rgba(0, 0, 0, 0.08);
        color: @primary-color;
        &:hover{
          color: @primary-color;
        }
      }
      &.ivu-menu-vertical .ivu-menu-item:hover,
      &.ivu-menu-vertical .ivu-menu-submenu-title:hover{
        color: rgba(0, 0, 0, 0.54);
        background-color: rgba(0, 0, 0, 0.08);
      }
      &.ivu-menu-vertical.ivu-menu-light:after{
        background-color: rgba(0, 0, 0, 0.12);
      }
    }
  }
</style>
